import React from "react"

import backgroundRdIcon from "./../assets/img/background_check_icon.png"

const Preloader = ({ show }) => {
  return (
    <div
      className={`preloader bg-soft flex-column justify-content-center align-items-center ${
        show ? "" : "show"
      }`}
    >
      <img
        className="loader-element animate__animated animate__jackInTheBox"
        src={backgroundRdIcon}
        alt="Loading"
        height={64}
      />
    </div>
  )
}

export default Preloader
